var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssignment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4706_24116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4706_24116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 13.9974C2.96667 13.9974 2.65278 13.8668 2.39167 13.6057C2.13056 13.3446 2 13.0307 2 12.6641V3.33073C2 2.96406 2.13056 2.65017 2.39167 2.38906C2.65278 2.12795 2.96667 1.9974 3.33333 1.9974H6.13333C6.27778 1.5974 6.51944 1.27517 6.85833 1.03073C7.19722 0.786285 7.57778 0.664062 8 0.664062C8.42222 0.664062 8.80278 0.786285 9.14167 1.03073C9.48056 1.27517 9.72222 1.5974 9.86667 1.9974H12.6667C13.0333 1.9974 13.3472 2.12795 13.6083 2.38906C13.8694 2.65017 14 2.96406 14 3.33073V12.6641C14 13.0307 13.8694 13.3446 13.6083 13.6057C13.3472 13.8668 13.0333 13.9974 12.6667 13.9974H3.33333ZM3.33333 12.6641H12.6667V3.33073H3.33333V12.6641ZM4.66667 11.3307H9.33333V9.9974H4.66667V11.3307ZM4.66667 8.66406H11.3333V7.33073H4.66667V8.66406ZM4.66667 5.9974H11.3333V4.66406H4.66667V5.9974ZM8 2.83073C8.14444 2.83073 8.26389 2.78351 8.35833 2.68906C8.45278 2.59462 8.5 2.47517 8.5 2.33073C8.5 2.18628 8.45278 2.06684 8.35833 1.9724C8.26389 1.87795 8.14444 1.83073 8 1.83073C7.85556 1.83073 7.73611 1.87795 7.64167 1.9724C7.54722 2.06684 7.5 2.18628 7.5 2.33073C7.5 2.47517 7.54722 2.59462 7.64167 2.68906C7.73611 2.78351 7.85556 2.83073 8 2.83073Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignment);
export default __webpack_public_path__ + "static/media/assignment.8bf0cfa09e36d0dcdb2d208e5b4ef0cc.svg";
export { ForwardRef as ReactComponent };